export default __webpack_public_path__ + "static/media/app.58779e44.png";